import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../App'
import { getBackendData } from '../../api/api'
import { ISwapCount } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getSwapCountConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_swap_count', timeframe)) as ISwapCount[]
	const series1 = chartData.map((element: ISwapCount) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_COUNT }
	})
	const series2 = chartData.map((element: ISwapCount) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SWAP_COUNT_CUMULATIVE }
	})
	const series3 = chartData.map((element: ISwapCount) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.L1_SWAP_COUNT }
	})
	const series4 = chartData.map((element: ISwapCount) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TRADE_SWAP_COUNT }
	})
	const series5 = chartData.map((element: ISwapCount) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SYNTH_SWAP_COUNT }
	})
	const series6 = chartData.map((element: ISwapCount) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.SECURED_SWAP_COUNT }
	})
	const config: IChart[] = [
		{
			data: series3,
			strokeWidth: 2,
			name: 'L1 swap count',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `orange`, //'#03a1fc',
			unitSymbol: '',
			barGroup: 'stacked'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'Synth swap count',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: 'green', //'#03fc6b',
			unitSymbol: '',
			barGroup: 'stacked'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'TA swap count',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: '#0ffc03', //'#03fc6b',
			unitSymbol: '',
			barGroup: 'stacked'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'SA swap count',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: 'yellow', //'#03fc6b',
			unitSymbol: '',
			barGroup: 'stacked'
		},
		// `	{
		// 		data: series3,
		// 		strokeWidth: 2,
		// 		name: 'total daily vol',
		// 		type: 'line',
		// 		seriesGroup: '[usd]',
		// 		color: `${inverseColor}`, //'green',
		// 		unitSymbol: '$'
		// 	},`
		{
			data: series2,
			strokeWidth: 2,
			name: 'cumulative swap count',
			type: 'line',
			seriesGroup: ' [swap #]',
			color: `${color}`, //'orange',
			unitSymbol: ''
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const SwapCount = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getSwapCountConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}

	return (
		<ChartPage
			chartTitle="Swap Count"
			chartDesc="Number of individual swap transactions executed per day. Useful for measuring network usage independent of dollar volume."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="498df68f-821b-41ce-b3c1-fe1a3ef2bf46"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default SwapCount
